<template>
  <div class="c-blogWidgetItemWrapper">
    <a
      :href="blogLink"
      target="_blank"
      rel="noopener"
    >
      <div class="c-blogWidgetItem">
        <div class="c-blogWidgetItem_inner">
          <div class="c-leftColumn">
            <div class="c-heading">
              <h3 class="c-heading_title">
                <a
                  :href="blogLink"
                  target="_blank"
                  rel="noopener"
                >{{ blog.title }}</a>
              </h3>
            </div>
            <div
              v-if="blog.summary.length > 0"
              class="c-leftColumn_summary"
            >
              {{ blog.summary }}
            </div>
            <div class="c-leftColumn_favoriteWrap">
              <span class="c-leftColumn_favorite">
                <CoconalaIcon
                  name="heart-o"
                  size="12px"
                />
                <span>{{ favoriteCount }}</span>
              </span>
              <span
                v-if="blog.isPurchased"
                class="c-leftColumn_purchased"
              >
                購入済み
              </span>
              <span
                v-else-if="blog.price > 0"
                class="c-leftColumn_price"
              >
                {{ blog.price | withDelimiter }}円
              </span>
            </div>
          </div>
          <div
            class="c-rightColumn"
            v-if="blog.resizableCoverImagePath"
          >
            <img
              class="c-rightColumn_coverImage"
              :src="$coconala.blogCoverImageURL(blog.resizableCoverImagePath)"
              alt="カバー画像"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
        <div class="c-blogWidgetItem_footer">
          <div class="c-postInfo">
            <a
              class="c-postInfo_userIcon"
              :href="`/blogs/${blog.userId}`"
              target="_blank"
              rel="noopener"
            >
              <CUserIconV2
                :file-path="user.userIconPath"
                :user-name="user.name"
                :size="32"
                :width="32"
                :height="32"
              />
            </a>
            <div class="c-postInfo_rightColumn">
              <a
                class="c-postInfo_userName"
                :href="`/blogs/${blog.userId}`"
                target="_blank"
                rel="noopener"
              >
                {{ user.name }}
              </a>
              <div class="c-postInfo_openedAt">
                {{ $util.dayjs.unix(blog.openedAt).format('YYYY/MM/DD') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </a>
    <a
      class="c-favorite"
      href="javascript:;"
      @click.prevent="toggleFavorite"
    >
      <CoconalaIcon
        class="c-favorite_icon"
        :class="{ 'c-favorite_icon-favorited': isFavorited }"
        name="heart"
        :size="isPC ? '25px' : '22px'"
      />
    </a>
  </div>
</template>
<script>
// vuex
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'BlogWidgetItem',
  props: {
    // DOM生成して渡すためStringで定義
    blog: {
      type: Object
    },
    user: {
      type: Object
    },
    blogRef: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isFavorited: false,
      favoriteCount: 0
    }
  },
  mounted() {
    this.isFavorited = this.blog.isFavorited
    this.favoriteCount = this.blog.favoriteCount
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('ui', ['isPC']),
    blogLink() {
      const params = {}
      if (this.blogRef !== '') {
        params.ref = this.blogRef
      }
      return this.$coconala.url(`/blogs/${this.blog.userId}/${this.blog.id}`, params)
    }
  },
  methods: {
    ...mapActions('ui', ['showLoginModal']),
    ...mapActions('pages/mypage/favorites/blogs', ['addFavorite', 'deleteFavorite']),
    async toggleFavorite() {
      // 未ログイン時はログインモーダルを表示する
      if (!this.isLoggedIn) {
        this.showLoginModal()
        return
      }

      if (!this.isFavorited) {
        await this.addFavorite({ blogId: this.blog.id })
          .then(() => {
            // 表示上のカウント数はトグルで増減させ、正確な集計値はバックエンドで計算する
            this.favoriteCount++
            this.isFavorited = true
          })
          .catch(error => {
            this.$notify({
              group: 'flash',
              title: 'お気に入りを追加できませんでした',
              type: 'error'
            })
          })
      } else {
        await this.deleteFavorite({ blogId: this.blog.id })
          .then(() => {
            if (this.favoriteCount > 0) {
              this.favoriteCount--
            }
            this.isFavorited = false
          })
          .catch(() => {
            this.$notify({
              group: 'flash',
              title: 'お気に入りを削除できませんでした',
              type: 'error'
            })
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-blogWidgetItemWrapper {
  position: relative;
}

.c-blogWidgetItem {
  @include link-effect;

  padding: 16px;
  height: 156px;
  border: 1px solid $color-gray-200;
  border-radius: 4px;
  color: $color-gray-900;

  a {
    position: relative;
    z-index: 2;
  }

  &_inner {
    display: flex;
    height: 84px;

    justify-content: space-between;
  }

  &_footer {
    display: flex;
    margin-top: 8px;

    align-items: flex-end;
    justify-content: space-between;
  }
}

.c-leftColumn {
  padding-right: 16px;

  flex-grow: 1;

  &_summary {
    @include multiline-ellipsis(2, 1.3em);

    margin-top: 4px;
    color: $color-font-base;
    font-size: 12px;
  }
  &_purchased {
    margin-left: 8px;
    padding-left: 8px;
    border-left: 1px solid $color-gray-300;
    color: $color-gray-600;
    font-size: 12px;
    line-height: 1;
  }
  &_price {
    margin-left: 8px;
    padding-left: 8px;
    border-left: 1px solid $color-gray-300;
    font-weight: bold;
    font-size: 12px;
    line-height: 1;
  }
  &_favoriteWrap {
    display: flex;
    margin-top: 4px;
  }
  &_favorite {
    color: $color-pink-500;
    font-size: 12px;
    line-height: 1;
  }
}

.c-heading {
  height: 22px;
  &_title {
    @include multiline-ellipsis(1, 1.3em);

    color: $color-gray-900;
    font-weight: bold;
    font-size: 16px;

    a {
      display: inline;
      color: $color-gray-900;
    }
  }
}

.c-postInfo {
  display: flex;

  align-items: center;

  &_userIcon {
    display: block;
    img {
      width: 32px;
      height: 32px;
    }
  }
  &_rightColumn {
    display: flex;
    flex-direction: column;
    margin-left: 4px;
  }
  &_userName {
    color: $color-gray-900;
    font-size: 11px;
    line-height: 1;
  }
  &_openedAt {
    margin-top: 4px;
    color: $color-gray-600;
    font-size: 10px;
    line-height: 1;
  }
}

.c-rightColumn {
  &_coverImage {
    display: block;
    max-width: 150px;
    border-radius: 6px;
  }
}

.c-favorite {
  @include link-effect;

  position: absolute;
  top: 114px;
  right: 20px;
  &_icon {
    color: $color-gray-300;
    &-favorited {
      color: $color-pink-500;
    }
  }
}

@media (max-width: 630px) {
  .c-blogWidgetItem {
    margin-top: 8px;
    padding: 16px;
    height: 126px;
    border: 1px solid $color-gray-200;
    border-radius: 4px;
    background-color: $color-white;

    &_inner {
      height: 56px;
    }
  }

  .c-leftColumn {
    &_summary {
      display: none;
    }
    &_purchased,
    &_price {
      margin-top: 0;
    }
  }

  .c-heading {
    max-height: 42px;
    height: inherit;
    &_title {
      @include multiline-ellipsis(2, 1.3em);

      font-size: 16px;
    }
  }

  .c-postInfo {
    position: relative;

    &_userIcon {
      height: 26px;
      img {
        width: 26px !important;
        height: 26px !important;
      }
    }
    &_userName {
      font-size: 12px;
    }
    &_openedAt {
      margin-top: 2px;
      font-size: 12px;
    }
  }

  .c-rightColumn {
    &_coverImage {
      max-width: 100px;
    }
  }
  .c-favorite {
    top: 84px;
  }
}
</style>
